// extracted by css-extract-rspack-plugin
export default {"root":"mdM7sC","pendingIndicator":"iMPISn","pendingPing":"EIqHsK","ping":"GWI82l","pendingDot":"Qfwqdz"};